export class ErrorCorrelationIdManager {
    private correlationId: number = parseInt((Date.now() / 1000).toString(), 10);

    public getNextCorrelationId(): string {
        this.correlationId++;
        return this.correlationId.toString(36).toUpperCase();
    }
}
